import React, { useState } from 'react';
import { Popover, Button, Typography } from 'antd';
import { SwapOutlined } from '@ant-design/icons';
import { Tenant } from '../types/tenant.types';
import SelectField from '../../../../common/SelectField';
import { useTenantList } from '../hooks/use-tenant.hook';
import { useTranslation } from 'react-i18next';
import { SelectValue } from 'antd/es/select';

const { Text } = Typography;

interface SysAdminTenantDropdownSelectorProps {
  selectedTenant?: Tenant;
  onTenantSelect: (tenantId: string | null) => void;
  disabled?: boolean;
  className?: string;
}

const SysAdminTenantDropdownSelectorComponent: React.FC<SysAdminTenantDropdownSelectorProps> = ({
  selectedTenant,
  onTenantSelect,
  disabled = false,
  className = '',
}) => {
  const { t } = useTranslation();
  const [popoverVisible, setPopoverVisible] = useState(false);

  const handleTenantChange = (value: SelectValue) => {
    onTenantSelect(value ? String(value) : null);
    setPopoverVisible(false);
  };

  const popoverContent = (
    <div className="p-3" style={{ minWidth: '20rem' }}>
      {selectedTenant ? (
        <div className="mb-3">
          <Text type="secondary">{t('tenants.currentlySelected')}</Text>
          <div className="mt-2 p-2 bg-light rounded">
            <Text strong className="d-block">
              {selectedTenant.name}
            </Text>
            <Text type="secondary" className="small">
              {selectedTenant.slug}
            </Text>
          </div>
        </div>
      ) : (
        <div className="mb-3">
          <Text type="secondary">{t('tenants.noTenantSelected')}</Text>
        </div>
      )}
      <div>
        <Text type="secondary" className="d-block mb-2">
          {t('tenants.switchTenant')}
        </Text>
        <SelectField
          useListHook={useTenantList}
          labelKey="name"
          valueKey="id"
          placeholder={t('tenants.selectActiveTenant')}
          value={selectedTenant?.id}
          onChange={handleTenantChange}
          disabled={disabled}
          className="w-100"
          selectProps={{ className: 'w-100' }}
          allowClear
        />
      </div>
    </div>
  );

  return (
    <div className={className}>
      <Popover
        content={popoverContent}
        trigger="click"
        open={popoverVisible}
        onOpenChange={setPopoverVisible}
        placement="bottomLeft"
        arrow={true}
        overlayStyle={{ zIndex: 1000 }}
      >
        <Button
          type="default"
          disabled={disabled}
          className="d-flex align-items-center justify-content-between"
          style={{ minWidth: '15rem' }}
        >
          {selectedTenant ? (
            <div className="d-flex flex-column align-items-start flex-grow-1">
              <Text strong className="lh-sm">
                {selectedTenant.name}
              </Text>
            </div>
          ) : (
            <Text type="secondary">{t('tenants.selectActiveTenant')}</Text>
          )}
          <SwapOutlined className="ms-2" />
        </Button>
      </Popover>
    </div>
  );
};

export default SysAdminTenantDropdownSelectorComponent;
